import { NgModule } from "@angular/core";
import { HeaderNotificationsComponent } from "./header-notifications.component";
import { DefaultModules } from "src/app/services/app.constants";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { ButtonModule } from "primeng/button";

@NgModule({
  declarations: [HeaderNotificationsComponent],
  imports: [
    ...DefaultModules,
    PerfectScrollbarModule,
    ButtonModule
  ],
  exports: [HeaderNotificationsComponent]
})
export class HeaderNotificationsModule { }
